export function calculateHighlightBarLeftValue(data, activeIndex) {
    const numberOfTabs = data.length;
    const tabWidth = 100 / numberOfTabs;
    return tabWidth * activeIndex;
}
